import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from 'src/app/globals';
import { Embalagem } from '../models/embalagem';

@Injectable({
  providedIn: 'root'
})
export class EmbalagemService {

  constructor(
    private http: HttpClient
  ) { }

  buscar(id) {
    return this.http.get<any>(globals.apiUrl + '/api/Embalagem/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  consultarEmbalagensComPaginacao(descricao: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, status, tipoEmbalagem) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('status', status);

    if (tipoEmbalagem != null) {
      parametros = parametros.set('tipoEmbalagem', tipoEmbalagem);
    }

    if (descricao.trim() !== '') {
      parametros = parametros.set('descri', descricao);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Embalagem/ListaPag',
      {
        params: parametros
      });
  }

  salvar(embalagem: Embalagem) {
    return this.http.post(globals.apiUrl + '/api/Embalagem/Salvar', embalagem);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/Embalagem/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  softDeleteEmbalagem(id) {
    return this.http.delete(globals.apiUrl + '/api/Embalagem/SoftDelete',
      { params: new HttpParams().set('id', id) });
  }
}
